
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/quickreply",
      function () {
        return require("private-next-pages/alternatives/quickreply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/quickreply"])
      });
    }
  